/**
 * PlanGate — R60.60: hard gate per moduli Plus-only (Ricette, Magazzino, Costi).
 *
 * Comportamento:
 *  - Se l'utente ha piano Plus/Executive legacy → mostra il children normalmente.
 *  - Se l'utente ha piano Base → redirect su /abbonamento con messaggio di upgrade.
 *
 * Scelta architetturale (R60.60): niente banner upsell dentro i moduli. Il piano
 * scelto resta per 12 mesi: non ha senso stressare il cliente Base con popup.
 * Il modulo è semplicemente invisibile dal menu e inaccessibile via URL diretto.
 */
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { hasPlusModules } from "@/lib/appVariant";

export default function PlanGate({ children }) {
  const { user, checking } = useAuth();
  if (checking) return null;
  if (!user) return <Navigate to="/login" replace />;
  // SA e Consulente (legacy) hanno sempre accesso completo
  if (user.role === "superadmin" || user.role === "consultant") return children;
  if (hasPlusModules(user)) return children;
  // Piano Base: redirect silenzioso al pannello abbonamento
  return <Navigate to="/abbonamento?gate=plus" replace />;
}
